/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */
import { create } from 'zustand';
import { RaFilterPanelState, RiskScoresFilterPanelStore } from '../types';
import { getActivityRangeDays } from '../getActivityDates';
import { raFilterPanelChangeManager } from './raFilterPanelChangeManager';
import { riskScoresResultsApi } from './riskScoresResults.state';
import { raFetchFilters } from '../api/raFetchFilters';

export const useRiskScoreFilterPanelStore = create<RiskScoresFilterPanelStore>(
  () => {
    const days = getActivityRangeDays();
    return {
      activityRangeOptions: days,
      activityRange: days[0].value,
      fraudTypeOptions: [],
      fraudType: '',
      searchBtnEnabled: false,
      loading: true,
    };
  }
);
const store = useRiskScoreFilterPanelStore;

export const riskScoresFilterPanelsApi = api();

function api() {
  let initialSearchInitiated = false;

  return {
    search,
    setRiskActivityRangeValue,
    setFraudTypeValue,
    submit,
    onRouteEnter,
    getCommittedSearchProps,
    setSearchDisabled,
    setSearchRestored,
    _resetOnRouteEnter,
  };

  async function search(fpState: RaFilterPanelState) {
    await riskScoresResultsApi.search(fpState);
  }

  async function submit() {
    if (!raFilterPanelChangeManager.isSubmittable(getFilterPanelState())) {
      return;
    }

    store.setState({ searchBtnEnabled: false });
    const fpState = commitState();
    await search(fpState);
  }

  function setRiskActivityRangeValue(value: string) {
    const searchBtnEnabled = raFilterPanelChangeManager.isSubmittable({
      ...getFilterPanelState(),
      activityRange: value,
    });

    store.setState({ activityRange: value, searchBtnEnabled });
  }
  function setFraudTypeValue(value: string) {
    const searchBtnEnabled = raFilterPanelChangeManager.isSubmittable({
      ...getFilterPanelState(),
      fraudType: value,
    });

    store.setState({ fraudType: value, searchBtnEnabled });
  }

  function commitState() {
    const state = getFilterPanelState();
    raFilterPanelChangeManager.commitSearchProps(state);
    return state;
  }

  function getFilterPanelState(): RaFilterPanelState {
    const { activityRange, fraudType } = store.getState();
    return {
      activityRange,
      fraudType,
    };
  }

  async function applyFilters() {
    const { result } = await raFetchFilters();
    const fraudType = result.length > 0 ? result[0].value : '';
    store.setState({ fraudTypeOptions: result, fraudType, loading: false });
  }

  async function onRouteEnter() {
    if (initialSearchInitiated) {
      return;
    }

    raFilterPanelChangeManager.setSubmitBlocked(false);
    await applyFilters();
    await search(getFilterPanelState());
    initialSearchInitiated = true;
  }

  function getCommittedSearchProps(): RaFilterPanelState {
    return raFilterPanelChangeManager.getCommittedSearchProps();
  }

  function setSearchDisabled() {
    store.setState({ searchBtnEnabled: false });
  }

  function setSearchRestored() {
    store.setState({
      searchBtnEnabled: raFilterPanelChangeManager.isSubmittable(
        getFilterPanelState()
      ),
    });
  }

  function _resetOnRouteEnter() {
    initialSearchInitiated = false;
  }
}
